import { render, staticRenderFns } from "./ai-email-modal.vue?vue&type=template&id=8f710690"
import script from "./ai-email-modal.vue?vue&type=script&lang=js"
export * from "./ai-email-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f710690')) {
      api.createRecord('8f710690', component.options)
    } else {
      api.reload('8f710690', component.options)
    }
    module.hot.accept("./ai-email-modal.vue?vue&type=template&id=8f710690", function () {
      api.rerender('8f710690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/ai-email-modal.vue"
export default component.exports